module.exports = __webpack_public_path__ + "static/assets/758ce94395d932d4943f61b3cc96cd1e.png";